module.exports = __webpack_public_path__ + "img/ecos-utra.47305f99.jpg";